import {
    CREATE_GARMENTS_PO_FAILURE,
    CREATE_GARMENTS_PO_REQUEST,
    CREATE_GARMENTS_PO_SUCCESS,
    CREATE_USER_FORM_GARMENTS_PO,
    FETCH_SINGLE_GARMENTS_PO_FAILURE,
    FETCH_SINGLE_GARMENTS_PO_REQUEST,
    FETCH_SINGLE_GARMENTS_PO_SUCCESS,
    FETCH_GARMENTS_PO_FAILURE,
    FETCH_GARMENTS_PO_REQUEST,
    FETCH_GARMENTS_PO_SUCCESS,
    NAVIGATE_GARMENTS_PO_DETAILS,
    NAVIGATE_GARMENTS_PO,
    GARMENTS_PO_USERFORM_RESET,
    UPDATE_GARMENTS_PO_FAILURE,
    UPDATE_GARMENTS_PO_REQUEST,
    UPDATE_GARMENTS_PO_SUCCESS,
    DELETE_GARMENTS_PO_REQUEST,
    DELETE_GARMENTS_PO_SUCCESS,
    DELETE_GARMENTS_PO_FAILURE,
    GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_GARMENTS_PO_INVOICE_REQUEST,
    FETCH_GARMENTS_PO_INVOICE_SUCCESS,
    FETCH_GARMENTS_PO_INVOICE_FAILURE,
    RESET_GARMENTS_PO_INVOICE_V2,
    FETCH_GARMENTS_PO_STYLE_REQUEST,
    FETCH_GARMENTS_PO_STYLE_SUCCESS,
    FETCH_GARMENTS_PO_STYLE_FAILURE,
    FETCH_GARMENTS_PO_FORMAT_REQUEST,
    FETCH_GARMENTS_PO_FORMAT_SUCCESS,
    FETCH_GARMENTS_PO_FORMAT_FAILURE,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_REQUEST,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_SUCCESS,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_FAILURE,
    DELETE_GARMENTS_PO_SUCCESS_CALL_OFF,
    SET_RETURNABLE_GRID_NAME_GARMENT_PO_HEADER,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_RESET,
    SET_PENDING_GRID_NAME_RADIO_CHANGE,
    DELETE_CALL_OFF_GARMENTS_PO_REQUEST,
    DELETE_CALL_OFF_GARMENTS_PO_FAILURE,
    DELETE_CALL_OFF_GARMENTS_PO_SUCCESS,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_GARMENTS_PO_PRINT
} from './garmentsPo.actionsType';

export const GARMENTS_PO = 'garmentsPo';

let initialState = {
    loading: false,
    GarmentsPO: [],
    GarmentsPOInvoiceV2: [],
    GarmentsPOStyle: [],
    GarmentsPOFormat: [],
    GarQtywithSizePrint: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedGarmentsDC: {},
    detailsId: '',
    activeKey: 1,
    isGarmentsPo: false,
    garmentsPOSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    renderGridBtn: 'finished',
    refresh: false,
    detailTextVar: 'details',
    headerSearchCall: true,

};

export let garmentsPoReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    if (type === 'CREATE_GARMENTS_PO_SUCCESS') {
        localStorage.setItem('DetailStyleIdCut', JSON.stringify(updatePayload));

    }
    switch (type) {
        case FETCH_GARMENTS_PO_REQUEST:
        case FETCH_GARMENTS_PO_STYLE_REQUEST:
        case FETCH_GARMENTS_PO_FORMAT_REQUEST:
        case FETCH_GARMENTS_PO_INVOICE_REQUEST:
        case CREATE_GARMENTS_PO_REQUEST:
        case FETCH_SINGLE_GARMENTS_PO_REQUEST:
        case UPDATE_GARMENTS_PO_REQUEST:
        case DELETE_GARMENTS_PO_REQUEST:
        case FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_REQUEST:
        case DELETE_CALL_OFF_GARMENTS_PO_REQUEST:
            return {
                ...state,
                loading: true
            };
        case SET_PENDING_GRID_NAME_RADIO_CHANGE:
            return {
                ...state,
                loading: false,
                renderGridBtn: payload
            }
        case SET_RETURNABLE_GRID_NAME_GARMENT_PO_HEADER:
            return {
                ...state,
                returnStatus: payload

            }
        case FETCH_GARMENTS_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                GarmentsPO: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case FETCH_GARMENTS_PO_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                GarmentsPOStyle: updatePayload?.PONO
            };
        case FETCH_GARMENTS_PO_FORMAT_SUCCESS:
            return {
                ...state,
                loading: false,
                GarmentsPOFormat: updatePayload
            };
        case FETCH_GARMENTS_PO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                GarmentsPOInvoiceV2: updatePayload
            };
        case FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_SUCCESS:
            return {
                ...state,
                loading: false,
                GarQtywithSizePrint: updatePayload?.CUD
            };
        case FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_RESET:
            return {
                ...state,
                loading: false,
                GarQtywithSizePrint: []
            }
        case CREATE_GARMENTS_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_GARMENTS_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedGarmentsPO: updatePayload,
                userform: updatePayload,
                refresh: !state.refresh,
            };
        case DELETE_GARMENTS_PO_SUCCESS_CALL_OFF:
            return {
                ...state,
                loading: false,
                callOffCheck: updatePayload
            }
        case UPDATE_GARMENTS_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_GARMENTS_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedGarmentsPO: {}
            };
        case DELETE_CALL_OFF_GARMENTS_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                callOfHeader: updatePayload
            }
        case FETCH_GARMENTS_PO_FAILURE:
        case FETCH_GARMENTS_PO_STYLE_FAILURE:
        case FETCH_GARMENTS_PO_FORMAT_FAILURE:
        case FETCH_GARMENTS_PO_INVOICE_FAILURE:
        case FETCH_SINGLE_GARMENTS_PO_FAILURE:
        case CREATE_GARMENTS_PO_FAILURE:
        case UPDATE_GARMENTS_PO_FAILURE:
        case DELETE_GARMENTS_PO_FAILURE:
        case FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_FAILURE:
        case DELETE_CALL_OFF_GARMENTS_PO_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GARMENTS_PO:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case GARMENTS_PO_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedGarmentsPO: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_GARMENTS_PO_DETAILS:
            return {
                ...state,
                isGarmentsPO: true,
                detailTextVar: payload,
                garmentsPOSelectedValue: updatePayload.garmentsPOSelectedValue
            };
        case NAVIGATE_GARMENTS_PO_PRINT:
            return {
                ...state,
                isGarmentsPO: false,
                garmentsPOSelectedValue: updatePayload.garmentsPOSelectedValue
            };
        case NAVIGATE_GARMENTS_PO:
            return {
                ...state,
                isGarmentsPO: false,
                detailTextVar: payload,
            };
        case RESET_GARMENTS_PO_INVOICE_V2:
            return {
                ...state,
                GarmentsPOInvoiceV2: []
            };
        case GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
